import React, {useEffect} from 'react';
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => {
    return {
        root: {
            zIndex: 100,
            width: '100 %',
            height: '100 %',
            position: 'fixed',
            border: 0,
            top: 0,
            right: 0,
            backgroundColor: 'white'
        },
    }
});

const PaymentForm = ({url, onSuccess, onFailed}) => {
    const classes = useStyles();
    usePaymentForm(onSuccess, onFailed)
    return <></>
    // return <iframe className={classes.root} src={url} width={'100%'} height={'100%'} title={'paying_form'}/>
}

export default PaymentForm;


const usePaymentForm = (onSuccess, onFailed) => {
    // const [showIframe, setShowIframe] = useState(true)
    const hideIframe = function (result) {
        if (result.origin === 'https://secure.meshulam.co.il' || result.origin === 'https://sandbox.meshulam.co.il') {
            switch (result.data.action) {
                case 'close' : {
                    onFailed({error:false})
                    break;
                }
                case 'payment' : {
                    if (+result.data.status === 1) {
                        onSuccess()
                    } else {
                        onFailed({error:true})
                    }
                    break;
                }

                case 'failed_to_load_page': {
                    onFailed({error:true})
                    break;
                }
                default:{

                }
            }
        }
    }
    useEffect(() => {
        window.addEventListener('message', hideIframe)
        return () => {
            window.removeEventListener('message', hideIframe)
        }
    })
}